var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 5.96478C16.5001 4.71742 15.4953 3.69382 14.2154 3.58969L13.6854 2.11277C13.2246 0.828856 11.7344 0.170173 10.4091 0.664656L2.44649 3.63557C2.36696 3.66525 2.2949 3.70529 2.23136 3.75344C1.31404 4.10657 0.666748 4.96359 0.666748 5.96478V13.1162C0.666748 14.4327 1.78604 15.5 3.16675 15.5L14.0001 15.5C15.3808 15.5 16.5001 14.4327 16.5001 13.1162V11.3144C16.9982 11.0396 17.3334 10.526 17.3334 9.93779V8.34858C17.3334 7.76035 16.9982 7.24677 16.5001 6.97199V5.96478ZM14.8334 6.75938V5.96478C14.8334 5.52593 14.4603 5.17017 14.0001 5.17017L3.16675 5.17017C2.70651 5.17017 2.33342 5.52593 2.33342 5.96478L2.33342 13.1162C2.33342 13.555 2.70651 13.9108 3.16675 13.9108L14.0001 13.9108C14.4603 13.9108 14.8334 13.555 14.8334 13.1162V11.527H14.0001C12.6194 11.527 11.5001 10.4597 11.5001 9.14318C11.5001 7.82665 12.6194 6.75938 14.0001 6.75938H14.8334ZM12.1085 2.6273L12.4508 3.58097L7.16666 3.58097L11.0164 2.14459C11.4582 1.97977 11.9549 2.19933 12.1085 2.6273ZM13.1667 9.14318C13.1667 8.70434 13.5398 8.34858 14.0001 8.34858H15.6667V9.93779H14.0001C13.5398 9.93779 13.1667 9.58203 13.1667 9.14318Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletsmall);
export default __webpack_public_path__ + "static/media/walletsmall.68c4324d0ee6a99a68b05b1b4e67379b.svg";
export { ForwardRef as ReactComponent };